import React, { useEffect, useState } from 'react';
import http from '../../services/http-service';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import './earning-list.css';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import checkValidationFormAllControls from '../../constants/validation';
// import FormGroup from '@mui/material/FormGroup';
import EditIcon from '@mui/icons-material/Edit';
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import debounce from 'lodash.debounce';
import Moment from 'moment';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';


const ModelStyle = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: '#fff !important',
    border: '2px solid #000', boxShadow: 'none', p: 4,
};

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));


function EarningList(props) {
    const [open, setOpen] = useState(false);
    const [openModel, setOpenModel] = useState(false)
    const [earningId, setEarningId] = useState();
    const [grossAmount, setGrossAmount] = useState();
    const [netAmount, setNetAmount] = useState();
    const [deductionAmount, setDeductionAmount] = useState();
    const [errorDisplay, seterrorDisplay] = useState('')
    const handleModelOpen = () => setOpenModel(true);
    const handleModelClose = () => setOpenModel(false);

    const history = useHistory();
    // history.go(0)
    const [count, setCount] = useState(0);
    const [searchItem, setSearchItem] = useState('');
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(parseInt(props.match.params.page))

    useEffect(() => {
        fetchEarningData(currentPage, searchItem);
        // eslint-disable-next-line
    }, []);


    const handleSearch = debounce((value) => {
        setSearchItem(value)
        setCurrentPage(1)
        history.push('/earning-list/' + 1)
        fetchEarningData(1, value)
    }, 1000)

    const fetchEarningData = (value, search) => {

        if (value)
            setCurrentPage(parseInt(value))
        else
            setCurrentPage(1)
        let params = {
            page: value,
            search: search
        }
        handleToggle()
        http('admin/user_earning_details_list/', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    setCount(0)
                    setCount(Math.ceil(res.data.count / res.data.page_size))
                    setTableData(res.data.results)
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId1"
                    })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const handlePageChange = (event, page) => {
        history.push('/earning-list/' + page);
        fetchEarningData(page, searchItem)
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const updateEarning = (event) => {
        event.preventDefault();
        var objValidation = {};
        objValidation = checkValidationFormAllControls(document.forms[0].elements, false, [])
        if (objValidation.valid !== false) {
            seterrorDisplay(objValidation);
            return;
        } else {
            seterrorDisplay(objValidation);
        }
        let postData = {
            "gross_amount": grossAmount ? grossAmount : 0,
            "net_amount": netAmount ? netAmount : 0,
            "deduction_amount": deductionAmount ? deductionAmount : 0
        }


        handleToggle()
        http('admin/user_earning_latest_details/' + earningId, 'PUT', postData)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    toast.success(res.message, {
                        toastId: "toastId2"
                    });
                    fetchEarningData(currentPage, searchItem)
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId3"
                    })
                }
                handleModelClose()
                handleClose()
            })
            .catch(error => {
                toast.error("Something went wrong!", {
                    toastId: "toastId4"
                })
                handleClose()
            });
    };

    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    const preventKeyDown = (e) => {
        if (e.code === 'ArrowDown') {
            e.preventDefault();
        }
    }

    return (
        <div className="mainAppDiv">
            {/* eslint-disable-next-line */}
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}

            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className='employeeHeading_row'>
                <div className='employeeHeading'> Earning Management </div>
                <Grid item lg={4} className='upsearchGrid'>
                    <Search className='upseacrchDiv'>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase onChange={(e) => {

                            handleSearch(e.target.value)
                        }}
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Search>
                </Grid>
                <Stack direction="row" spacing={2} className="justifyEnd">
                    {/* <Button variant="contained" onClick={addEmployee}>Add Employee</Button> */}
                </Stack>
            </div>

            {/* eslint-disable-next-line */}
            {
                tableData.length > 0 ?
                    <div>
                        <div className='customTable'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Earning ID</th>
                                        <th>Employee ID</th>
                                        <th>Employer ID</th>
                                        <th>Employer Name</th>
                                        <th>Gross Amount</th>
                                        <th>Net Amount</th>
                                        <th>Deduction Amount</th>
                                        <th>Paycheck Date</th>
                                        <th>Period Start Date</th>
                                        <th>Period End Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {tableData.map((data, index) => (
                                        <tr key={index}>
                                            <td key={'earning_id' + index}>{data.earning_id}</td>
                                            <td key={'employee_id' + index}>{data.employee_id}</td>
                                            <td key={'employer_id' + index}>{data.employer_id}</td>
                                            <td key={'employer_name' + index}>{data.employer_name}</td>
                                            <td key={'gross_amount' + index}>{data.gross_amount}</td>
                                            <td key={'net_amount' + index}>{data.net_amount}</td>
                                            <td key={'deduction_amount' + index}>{data.deduction_amount}</td>
                                            <td key={'paycheck_date' + index}>{data.paycheck_date ? Moment(data.paycheck_date).format('lll') : ""}</td>
                                            <td key={'period_start_date' + index}>{data.period_start_date ? Moment(data.period_start_date).format('lll') : ""}</td>
                                            <td key={'period_end_date' + index}>{data.period_end_date ? Moment(data.period_end_date).format('lll') : ""}</td>
                                            <td>
                                                <div>
                                                    <Button className="colorGreen ml-10 cursorStyle"><EditIcon
                                                        onClick={() => {
                                                            setEarningId(data.id)
                                                            setGrossAmount(data.gross_amount)
                                                            setNetAmount(data.net_amount)
                                                            setDeductionAmount(data.deduction_amount)
                                                            handleModelOpen()
                                                        }}
                                                    ></EditIcon>
                                                    </Button>

                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Modal
                                open={openModel}
                                onClose={handleModelClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={ModelStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center', paddingBottom: '20px', borderBottom: '1px solid #ddd', marginBottom: '20px' }}>
                                        Update Earning
                                    </Typography>



                                    <Box component="form" sx={{ '& > :not(style)': { my: 1, width: '100%' } }} noValidate autoComplete="off">
                                        <TextField item inputProps={{ type: "number" }} onKeyPress={preventMinus} onKeyDown={preventKeyDown} id="gross_amount" label="Gross Amount" name='gross_amount' placeholder='Gross Amount' fullWidth required
                                            value={grossAmount} min="0" onChange={(event) => {
                                                setGrossAmount(event.target.value)
                                            }}
                                        />
                                        {errorDisplay.gross_amount ? <span style={{
                                            fontSize: '14px',
                                            color: '#dc0e0e'
                                        }}>{errorDisplay.gross_amount}</span> : ''}
                                        <TextField item inputProps={{ type: "number" }} name='net_amount' id="net_amount" onKeyPress={preventMinus} onKeyDown={preventKeyDown} label="Net Amount" placeholder='Net Amount' fullWidth required
                                            value={netAmount} min="0" onChange={(event) => {
                                                setNetAmount(event.target.value)
                                            }}
                                        />
                                        {errorDisplay.net_amount ? <span style={{
                                            fontSize: '14px',
                                            color: '#dc0e0e'
                                        }}>{errorDisplay.net_amount}</span> : ''}
                                        <TextField item inputProps={{ type: "number" }} name='deduction_amount' id="deduction_amount" onKeyPress={preventMinus} onKeyDown={preventKeyDown} label="Deduction Amount" placeholder='Deduction Amount' fullWidth required
                                            value={deductionAmount} min="0" onChange={(event) => {
                                                setDeductionAmount(event.target.value)
                                            }}
                                        />
                                        {errorDisplay.deduction_amount ? <span style={{
                                            fontSize: '14px',
                                            color: '#dc0e0e'
                                        }}>{errorDisplay.deduction_amount}</span> : ''}

                                        <Stack spacing={2} direction="row" sx={{ justifyContent: 'flex-end' }}>
                                            <button type='button' className='btnSubmit btnCancel' onClick={handleModelClose}>Cancel</button>
                                            <button type='button' onClick={updateEarning} className='btnSubmit'>Update</button>
                                        </Stack>
                                    </Box>
                                </Box>
                            </Modal>
                        </div>

                        <Stack spacing={2} className="employeePagination">
                            <Pagination count={count} page={currentPage} color="primary" onChange={handlePageChange} />
                        </Stack>
                    </div> :
                    <div className='recordNotFoundDiv'>
                        <h2>Records Not Found</h2>
                    </div>
            }
        </div>
    )

}
export default EarningList;